export default (el, visibleClass = 'active') => {
    return el.classList.add(visibleClass);
};
